export default __webpack_public_path__ + "static/media/time.9b72f181.svg";